export default "__VITE_ASSET__DSArgCxj__"